import register from '../../../../global/js/registry';
export default register('m-search-autosuggestion-hits', () => import(/* webpackMode: "lazy" */ './m-search-autosuggestion-hits.controller'));
